module.exports = __webpack_public_path__ + "static/img/active3.7e9b63d9.png";